import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-card',
  styleUrls: ['card.component.scss'],
  templateUrl: 'card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() icon!: string;
  @Input() title!: string;
  @Input() description!: string;
}
